import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquareQuote } from 'lucide-react';
import { featuredTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 bg-cream border-y border-silver-light" data-id="element-283" data-mp="3sqtnsx4sldm8">
      <div className="max-w-7xl mx-auto px-4" data-id="element-284" data-mp="3nzlhwb2o8adt">
        <p className="text-center text-xs font-semibold uppercase tracking-widest text-graphite-light mb-6" data-id="element-285" data-mp="3nytkqvtfe4lf">
          Coach stories — use verified customer reviews in this section
        </p>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-286" data-mp="lhizolmky1o">
          {featuredTestimonials.map((testimonial, index) => <motion.div key={testimonial.initials} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-paper border border-silver-light p-6 rounded-2xl flex flex-col" data-id="element-287" data-mp="fj9w6a3p9acp" data-mpi={index}>
              <MessageSquareQuote className="text-accent mb-4" size={18} aria-hidden="true" data-id="element-288" data-mp="ceabhdzlwe9k" />
              <p className="text-graphite mb-6 text-sm leading-relaxed" data-id="element-289" data-mp="gf41ccwm0353">{testimonial.text}</p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-290" data-mp="lcm05agwx1zd">
                <div className="w-10 h-10 rounded-full bg-cream border border-silver flex items-center justify-center text-ink font-display font-bold" data-id="element-291" data-mp="q3ucae9mn1g8">
                  {testimonial.initials}
                </div>
                <div data-id="element-292" data-mp="101iflslatha0">
                  <div className="font-bold text-ink text-sm" data-id="element-293" data-mp="100z16luuxb0q">{testimonial.name}</div>
                  <div className="text-xs text-graphite-light" data-id="element-294" data-mp="144ydstd0npot">{testimonial.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}